import { getDatabase, onValue, query, ref } from "firebase/database";
import { useEffect, useState } from "react";
export default function useEarningHistory(userId) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [earningHistoryList, setEarningHistoryList] = useState([]);
  useEffect(() => {
    async function fetchUsers() {
      //databse related works
      const db = getDatabase();
      const earningRef = ref(db, `EarningHistory/${userId}`);
      const earningQuery = query(earningRef);
      console.log(earningQuery);

      try {
        setError(false);
        setLoading(true);
        //request firebase database;
        onValue(earningQuery, (snapshot) => {
          setLoading(false);
          if (snapshot.exists()) {
            console.log(snapshot.val());
            setEarningHistoryList((prevCashout) => {
              return [...Object.values(snapshot.val())];
            });
          }
        });
      } catch (err) {
        setLoading(false);
        setError(true);
      }
    }
    fetchUsers();
  }, [userId]);

  return { loading, error, earningHistoryList };
}
